export { default } from './ModalsGlobal'
